import { ButtonHTMLAttributes } from 'react';
import BsButton from 'react-bootstrap/Button';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline';
  fullWidth?: boolean;
  size?: 'sm' | 'lg';
}

export function Button({ variant = 'primary', fullWidth = true, size, style, className, children, ...props }: ButtonProps) {
  const estiloPrimario =
    variant === 'primary'
      ? {
          background: 'var(--cor-gradiente)',
          border: 'none',
          fontWeight: 600,
        }
      : {
          fontWeight: 600,
        };

  return (
    <BsButton
      variant={variant === 'primary' ? 'primary' : 'outline-primary'}
      size={size}
      className={`${fullWidth ? 'w-100' : ''} lizzi-button ${className ?? ''}`.trim()}
      style={{ ...estiloPrimario, ...style }}
      {...props}
    >
      {children}
    </BsButton>
  );
}
